<template>
  <section class="card-text">
    <p class="name">{{ theName }}</p>
    <p class="type" v-if="price">v.a. {{ price }}</p>
    <p
      v-else
      class="type"
      :class="{ package: type && type.toLowerCase() === 'package' }"
    >
      {{ typeTitle }}
    </p>
    <button class="info-btn" v-if="info" @click.stop="$emit('showInfo')">
      <img  src="@/images/icons/info-icon.svg" />
    </button>
    <div class="colors" v-if="colors">
      <div
        class="color"
        v-for="color in colors"
        :key="color.name"
        :style="{ 'background-color': color.color }"
      ></div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    type: String,
    name: String,
    subtitle: String,
    price: String,
    colors: Object,
    info: {
      default: false
    }
  },
  data() {
    return {
      theName: this.name.replace(/-/g, '‑')
    }
  },
  computed: {
    typeTitle() {
      if (!this.type) {
        return ''
      } else if (this.type.toLowerCase() === 'collection') {
        return this.subtitle
        //return this.count === 1 ? '1 product' : `${this.count} producten`
      } else if (this.type.toLowerCase() === 'package') {
        return 'Kant-en-klaar pakket'
      } else {
        return this.type
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.card-text {
  height: 84px;
  width: 100%;
  background-color: #f4f4f4;
  border-radius: 20px;
  padding: 12px;
  text-align: left;
  position: relative;
}

.info-btn {
  position: absolute;
  bottom: 5px;
  right: 8px;
  border: none;

  circle {
    stroke: var(--sub-color);
  }

  rect {
    fill: var(--sub-color);
  }
}

.name {
  font-weight: 600;
  //word-break: break-word;
  line-height: 17px;
  max-height: 34px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.type {
  font-style: italic;
  position: absolute;
  bottom: 7px;
  font-size: 12px;
}

.package {
  background: #4f4f4f;
  font-weight: 500;
  padding: 2px 9px;
  border-radius: 30px;
  color: white;
  font-size: 10px;
  display: inline-block;
  margin-top: 4px;
  margin-left: -3px;
  position: absolute;
  left: 13px;
  bottom: 7px;
}
.colors {
  position: absolute;
  right: 12px;
  bottom: 5px;
}
.color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 12px;
  margin-left: 2px;
}
</style>
